export default __webpack_public_path__ + "static/media/Gear.7b314faa.jpg";